import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ActivityTitle } from "../../activities/me-meta";
import { MeInstructionsDialogComponent } from "./me-instructions-dialog/me-instructions-dialog.component";
import { MeTipsDialogComponent } from "./me-tips-dialog/me-tips-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { ResponsiveDesignService } from "../../services/responsive-design/responsive-design.service";

@Injectable({
	providedIn: 'root'
})
export class MeTipsService {

	public static readonly WITHOUT_INDEX_INSTRUCTION = false;
	public static readonly WITH_INDEX_INSTRUCTION = true;

	private dialog!: MatDialogRef<MeTipsDialogComponent | MeInstructionsDialogComponent, null>;
	
	private  mapKeyword : Map<string, RedirectData> = new Map();

	constructor(
		private srvDialog: MatDialog,
		private translate: TranslateService,
		private srvRpDesign: ResponsiveDesignService) {

			this.mapKeyword.set("LIST_SCH_PAYMENT",{route: "/scheduled-transactions", data: {}, label: translate.instant("LABEL_LIST_SCH_PAYMENT")});
			this.mapKeyword.set("LIST_SCH_TRANSFER",{route: "/scheduled-transactions", data: {}, label: translate.instant("LABEL_LIST_SCH_TRANSFER")});
			this.mapKeyword.set("ADD_SCH_PAYMENT",{route: "/payment/general", data: {  source: "schedule" }, label: translate.instant("LABEL_ADD_SCH_PAYMENT") });
			this.mapKeyword.set("ADD_SCH_TRANSFER",{route: "/internal-transfer", data: {source: "schedule"}, label: translate.instant("LABEL_ADD_SCH_TRANSFER") });
			this.mapKeyword.set("VIEW_RESOURCE_CUSTOMER_WEALTH",{route: "/resource-viewer", data: {}, label: translate.instant("LABEL_VIEW_RESOURCE_CUSTOMER_WEALTH") });
			this.mapKeyword.set("VIEW_RESOURCE_CUSTOMER_DDA",{route: "/resource-viewer", data: {}, label: translate.instant("LABEL_VIEW_RESOURCE_CUSTOMER_DDA") });
			this.mapKeyword.set("VIEW_RESOURCE_CUSTOMER_SAV",{route: "/resource-viewer", data: {}, label: translate.instant("LABEL_VIEW_RESOURCE_CUSTOMER_SAV") });
			this.mapKeyword.set("VIEW_RESOURCE_CUSTOMER_CC",{route: "/resource-viewer", data: {}, label: translate.instant("LABEL_VIEW_RESOURCE_CUSTOMER_CC") });
			this.mapKeyword.set("LIST_FINANCIAL_GOAL",{route: "/personal-finance-management", data: {}, label: translate.instant("LABEL_LIST_FINANCIAL_GOAL") });
			this.mapKeyword.set("ADD_FINANCIAL_GOAL",{route: "/personal-finance-management", data: { state: "goal_create"}, label: translate.instant("LABEL_ADD_FINANCIAL_GOAL") });
	}

	private readonly setTipsDialogConfig = (data: any) => {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = data;
		dialogConfig.maxWidth = 800;
		dialogConfig.width = '98%';
		dialogConfig.height = 'auto';
		dialogConfig.panelClass = this.srvRpDesign.getResponsiveClass('custom-dialog-tips', 'mobile-custom-dialog-tips');
		return dialogConfig;
	};

	openTipsDialog(tipsData: TipsData): Observable<null | undefined> {
		this.dialog = this.srvDialog.open(MeTipsDialogComponent, this.setTipsDialogConfig(tipsData));
		return this.dialog.afterClosed();
	}

	openInstructionsDialog(instructionsData: ActivityTitle): Observable<null | undefined> {
		this.dialog = this.srvDialog.open(MeInstructionsDialogComponent, this.setTipsDialogConfig(instructionsData));
		return this.dialog.afterClosed();
	}

	public buildInstructionGroupData(title: string, instructionTexts: string[], withIndexedInstructions: boolean = MeTipsService.WITH_INDEX_INSTRUCTION, styleTexts: string[] = []): InstructionGroupData {
		let instructions: InstructionData[] = instructionTexts.map((text, index) => {
			let style = '';
			if (styleTexts[index] !== 'undefined') {
				style = styleTexts[index];
			}
			let item: InstructionData = {
				index: index + 1,
				instruction: this.translate.instant(text),
				style: style,
				displayCondition: true
			}
			return item;
		});
		let instruction: InstructionGroupData = {
			title: this.translate.instant(title),
			instructions: instructions,
			withIndexedInstructions: withIndexedInstructions,
		};
		return instruction;
	}

	public buildTipsData(label: string, tipsMessage: string[], displayCondition: boolean = true, tipsStyle: string[] = []): TipsData {
		return {
			label: label,
			tipsMessage: tipsMessage,
			tipsStyle: tipsStyle,
			displayCondition: displayCondition
		};
	}

	public buildActivityTips(header: string, detail: string[], withIndexedInstructions: boolean = MeTipsService.WITH_INDEX_INSTRUCTION, style: string[] = []): ActivityTitle {
		let instruction: InstructionGroupData = this.buildInstructionGroupData(header, detail, withIndexedInstructions, style);
		return new ActivityTitle("").setInstructionsData(instruction);
	}

	public buildSimpleActivityTip(header: string, detail: string, withIndexedInstructions: boolean = MeTipsService.WITHOUT_INDEX_INSTRUCTION, style: string[] = []): ActivityTitle {
		let newHeader = this.translate.instant(header);
		let newDetail = this.translate.instant(detail);
		let instruction: InstructionGroupData = this.buildInstructionGroupData(newHeader, [newDetail], withIndexedInstructions, style);
		return new ActivityTitle("").setInstructionsData(instruction);
	}

	public getRedirectData(keyword : string) : RedirectData | undefined {
		return this.mapKeyword.get(keyword);
	}

}
export interface RedirectData {
	route: string;
	data: any;
	label: string;
}

export interface TipsData {
	label: string;
	tipsMessage: string[];
	tipsStyle?: string[],
	displayCondition?: boolean;
}

export interface InstructionData {
	index: number;
	instruction: string;
	style?: string;
	displayCondition?: boolean;
}

export interface InstructionGroupData {
	title: string;
	instructions: InstructionData[];
	withIndexedInstructions?: boolean;
	tipList?: TipsData[];
}
